import TennisTable from "./TennisTable";
export const firstTennisSection = [
  {
    name: "Row 1",
    left: [],
    right: [
      { column1: "Overall Size", column2: "396ft x 120ft" },
      { column1: "Total Area", column2: "47,520 sq.ft./5,280 sq.yds" },
      { column1: "Playing Area", column2: "22,464 sq.ft./2,496 sq.yds" },
      { column1: "Outside Court Area", column2: "25,056 sq.ft./2,784 sq.yds" },
    ],
  },
];

export const secondTennisSection = [
  {
    name: "Row 2",
    left: ["Acrylic Resurfacer", "Acrylic Resurfacer With Sand"],
    right: [
      { column1: "One Coat", column2: "385 Gallons" },
      { column1: "One Coat", column2: "600 Gallons" },
    ],
  },
];

export const thirdTennisSection = [
  {
    name: "Row 3",
    left: [
      "Color /Neutral Concentrate",
      "Color/Neutral Concentrate w/Sand",
      "Color /Neutral Concentrate Ready-Mix Color",
    ],
    right: [
      { column1: "Two Coats", column2: "250 Gallons" },
      { column1: "Two Coats", column2: "350 Gallons" },
      { column1: "Two Coats", column2: "600 Gallons" },
    ],
  },
];

export const forthTennisSection = [
  {
    name: "Row 4",
    left: [
      "Color /Neutral Concentrate",
      "Color/Neutral Concentrate w/Sand",
      "Color /Neutral Concentrate Ready-Mix Color",
    ],
    right: [
      { column1: "Two Coats", column2: "300 Gallons" },
      { column1: "Two Coats", column2: "415 Gallons" },
      { column1: "Two Coats", column2: "710 Gallons" },
    ],
  },
];

export const fifthTennisSection = [
  {
    name: "Row 5",
    left: ["CushionMaster II (Coarse Rubber)", "CushionMaster I (Fine Rubber)"],
    right: [
      { column1: "Three Coats", column2: "2450 Gallons" },
      { column1: "Two Coats", column2: "1090 Gallons" },
    ],
  },
];

export const sixthTennisSection = [
  {
    name: "Row 6",
    left: ["Stripe Rite", "White Line Paint"],
    right: [
      { column1: "One Coat", column2: "8 Gallons" },
      { column1: "One Coat", column2: "8 Gallons" },
    ],
  },
];

export const sevenTennisSection = [
  {
    name: "Row 7",
    left: ["Standard Size Roll"],
    right: [{ column1: "64 Rolls" }],
    right: [{ column1: "64 Rolls" }],
  },
];

const TennisEightVertical = () => {
  return (
    <>
      <TennisTable rows={firstTennisSection} hidden={true} />
      <TennisTable
        rows={secondTennisSection}
        leftCol={"Total Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={thirdTennisSection}
        leftCol={"Inside Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={forthTennisSection}
        leftCol={"Outside Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={fifthTennisSection}
        leftCol={"ProCushion LAYERS"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={sixthTennisSection}
        leftCol={"STRIPING"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={sevenTennisSection}
        leftCol={"MASKING TAPE"}
        middleCol={"Rolls Needed"}
      />
    </>
  );
};

export default TennisEightVertical;
